import { usePerformanceChart, useTheme } from "@hooks";
import { PATH_SHADOW_GRADIENT_ID, PathShadow } from "./PathShadow";

export const MainPath = () => {
  const { theme } = useTheme();

  const { strokeWidth, path, selectedChart } = usePerformanceChart();

  const pathShadow = selectedChart.pathShadow;

  const strokeColor = theme.chart.performance.stroke;

  if (!path || !pathShadow) return null;

  return (
    <>
      <path d={path} stroke={strokeColor} strokeWidth={strokeWidth} fill="none" />

      <path d={pathShadow} fill={`url(#${PATH_SHADOW_GRADIENT_ID})`} />

      <PathShadow />
    </>
  );
};
